import React from 'react';
import { useTranslation } from 'react-i18next';
import { IconClose, IconLink } from '@punchcard/core/icons';

// Tooltip positioning constants
const TOOLTIP_VERTICAL_OFFSET = 42;
const TOOLTIP_HORIZONTAL_OFFSET = 100;

interface InternalLinkTooltipProps {
	isVisible: boolean;
	position: { x: number; y: number };
	linkId: number | null;
	linkPage: number | null;
	onNavigate: (id: number, page: number) => void;
	onClose: () => void;
}

const InternalLinkTooltip: React.FC<InternalLinkTooltipProps> = ({
	isVisible,
	position,
	linkId,
	linkPage,
	onNavigate,
	onClose
}) => {
	const { t } = useTranslation();

	if (!isVisible) {
		return null;
	}

	const handleNavigateClick = (e: React.MouseEvent) => {
		e.stopPropagation();
		onNavigate(linkId || 0, linkPage || 0);
		onClose();
	};

	const handleCloseClick = (e: React.MouseEvent) => {
		e.stopPropagation();
		onClose();
	};

	const handleKeyDown = (e: React.KeyboardEvent) => {
		if (e.key === 'Enter' || e.key === ' ') {
			e.preventDefault();
			onNavigate(linkId || 0, linkPage || 0);
			onClose();
		}
	};

	return (
		<div
			className="tooltip-internal-link rounded px-2 py-1"
			style={{
				position: 'absolute',
				top: position.y - TOOLTIP_VERTICAL_OFFSET,
				left: position.x - TOOLTIP_HORIZONTAL_OFFSET,
			}}
		>
			<button
				className="tooltip-internal-link"
				onClick={handleNavigateClick}
				tabIndex={0}
				onKeyDown={handleKeyDown}
			>
				<IconLink className="me-1 icon-18" />
				{t('wip.go_to_resource')}
			</button>
			<button
				className="tooltip-internal-link border-start"
				onClick={handleCloseClick}
			>
				<IconClose className="icon-18" />
			</button>
			{/* Tooltip arrow pointing downward */}
			<div className="tooltip-internal-link-arrow" />
		</div>
	);
};

export default InternalLinkTooltip;
